import { useParams, Navigate, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { useTranslation } from "react-i18next";
import { graphqlClient } from "@/lib/graphql";

const COLLECTION_FOR_GROUP_QUERY = gql`
  query CollectionForGroup($groupId: String!) {
    collectionForGroup(groupId: $groupId) {
      id
    }
  }
`;

export function ListingGroupPage() {
  const { groupId } = useParams<{ groupId: string }>();
  const { t } = useTranslation();

  const { data, isLoading } = useQuery({
    queryKey: ["collectionForGroup", groupId],
    queryFn: () =>
      graphqlClient.request<{ collectionForGroup: { id: string } | null }>(
        COLLECTION_FOR_GROUP_QUERY,
        { groupId },
      ),
    enabled: !!groupId,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-800 border-t-transparent" />
      </div>
    );
  }

  const collection = data?.collectionForGroup;
  if (collection) {
    return <Navigate to={`/collections/${collection.id}`} replace />;
  }

  return (
    <div className="py-20 text-center">
      <p className="text-lg text-gray-500">{t("collections.not_found")}</p>
      <Link
        to="/listings"
        className="mt-4 inline-block text-sm font-medium text-primary-800 hover:text-primary-700"
      >
        {t("collections.back_to_listings")}
      </Link>
    </div>
  );
}
